module.exports = __webpack_public_path__ + "src/assets/bx_msg_square_edit.png";